module.exports = __webpack_public_path__ + "media/packs/images/flags/GU-6dbe6c36bebcb2a87eea3b2beaf8911c.png";